import axiosInstance from "./AxiosInstance";
import config from "../config";

export const fetchAllExcelSheets = () => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: config.routes.excel,
    method: "get",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const createExcelSheet = (name, file, desc) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: config.routes.excel,
    method: "post",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: {
      name: name,
      file: file,
      description: desc,
    },
  });
};

export const updateExcelSheet = (id) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: config.routes.updateExcel(id),
    method: "put",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const fetchExcelById = (id) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: config.routes.getExcel(id),
    method: "get",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const deleteExcelById = (id) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: config.routes.deleteExcel(id),
    method: "delete",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const uploadExcelFile = (formData, id) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: config.routes.uploadExcelFile(id),
    method: "post",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data",
    },
    data: formData,
  });
};
